import $ from 'jquery';

export default () => {

    $('.hamburger').on("click", function () {
        $('#offcanvasMenu').addClass('display');
        setTimeout(() => { fade_elements_in_recursively($('.childs-fade-in').children()); }, 150);
    });
    $('.btn-x').on("click", function () {
        $('#offcanvasMenu').removeClass('display');
        $('.childs-fade-in > *').css('opacity','0');
    });
}

function fade_elements_in_recursively(elements_list) {
    elements_list[0].style.opacity = "1";                                       // mostra primo elemento
    if(elements_list.length > 1) {                                              // controlla se sono presenti altri elementi
        elements_list = elements_list.slice(1);                                     // rimuove l'elemento gia mostrato
        setTimeout(() => { fade_elements_in_recursively(elements_list); }, 40);     // ripeti la funzione con nuovo array
    }
}


// WEBPACK FOOTER //
// ../views/partials/hamburger/hamburger.js